
<div [id]="'chart-container'+id" [style]="'width: 100%; height:'+height">

</div>

<script src="https://code.highcharts.com/modules/pattern-fill.js"></script>
<script src="https://cdn.jsdelivr.net/npm/chart.js"></script>
